import request from '@/utils/request'
import { BASE_API } from '@/api/baseUrl'

/**
 * 发货运费设置
 * 查询
 * @param {*} params
 */
export function apiFindShippingFeeDetail(data) {
  return request({
    url: BASE_API() + '/shippingfee/findShippingFeeDetail',
    method: 'post',
    data
  })
}

/**
 * 发货运费设置
 * 保存
 * @param {*} params
 */
export function apiFindShippingFeeAdd(data) {
  return request({
    url: BASE_API() + '/shippingfee/add',
    method: 'post',
    data
  })
}

/**
 * 仓库查询
 * 查询
 * @param {*} params
 */
export function apiFindWarehouse(data) {
  return request({
    url: BASE_API() + '/shippingfee/findWarehouse',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/applyForGoods/shippingfee.js